import TimePicker from './component'

export default TimePicker
